module.exports = __webpack_public_path__ + "img/37.f5d462e7.jpg";